const Viscosity = ({value}) =>
  value ? `${String(value).padStart(3, "0")} sec.` : "n/a"

export default Viscosity



// WEBPACK FOOTER //
// ./src/components/decorators/Viscosity.js